// extracted by mini-css-extract-plugin
module.exports = {"footerCopyright":"Footer_footerCopyright__xhaA5"};